import { WebCommonSettings } from '../types/settingsTypes';
import LocalStorageUtils from './local-storage';

const WEB_COMMON_SETTINGS_STORAGE_KEY = 'webCommonSettings';

const normalizeWebCommonSettings = (settings: Partial<WebCommonSettings> | null | undefined): WebCommonSettings => {
  return {
    ...new WebCommonSettings(),
    ...(settings || {})
  };
};

const persistWebCommonSettings = (settings: WebCommonSettings): void => {
  try {
    LocalStorageUtils.putValueToLocalStorage(WEB_COMMON_SETTINGS_STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // Ignore storage errors: runtime state still updates through Redux.
  }
};

export const cacheWebCommonSettings = (settings: Partial<WebCommonSettings>): WebCommonSettings => {
  const normalizedSettings = normalizeWebCommonSettings(settings);

  persistWebCommonSettings(normalizedSettings);

  return normalizedSettings;
};

export const getCachedWebCommonSettings = (): WebCommonSettings | null => {
  try {
    const rawSettings = LocalStorageUtils.getValueFromLocalStorage(WEB_COMMON_SETTINGS_STORAGE_KEY);

    if (!rawSettings) {
      return null;
    }

    const parsedSettings = JSON.parse(rawSettings) as Partial<WebCommonSettings> | null;

    if (!parsedSettings || typeof parsedSettings !== 'object') {
      return null;
    }

    return normalizeWebCommonSettings(parsedSettings);
  } catch {
    return null;
  }
};
